import axios from "@/plugins/axios";

let url = "/api/plugins/open-bank";

export const checkpay = {
    /**
     * 결제 시작 — 510 리다이렉트 전문 발급.
     * 응답 { checkout: { url, params } } 을 자동제출 폼으로 쿠콘 결제창에 전송한다.
     * @param {{ orderNo: string, ci: string, membCd?: string }} data
     * @returns {Promise<{ success: boolean, checkout: { url: string, params: object } }>}
     */
    request(data) {
        return axios.post(`${url}/request`, data).then((result) => result.data);
    },
};
